



// This example shows you how to set up React Stripe.js and use Elements.
// Learn how to accept a payment using the official Stripe docs.
// https://www.stripe.com/docs/payments/integration-builder

import React, {
  useState,
  useEffect, Component
} from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  ProgressBar,
  ButtonGroup, ToggleButton
} from 'react-bootstrap';
import {
  CardElement,
  Elements,
  useElements,
  useStripe
} from "@stripe/react-stripe-js";

import emailjs from 'emailjs-com';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

//import "./styles.css";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import ReactPlayer from "react-player";
import ShareButtons from "../components/sharebuttons";
import FooterPage from "../partials/footerPage";
import Cookies from "universal-cookie";
const cookies = new Cookies();



const stripePromise = loadStripe("pk_live_51IjpZHBrw3XSlH4n5h1DIg0wbL3fwJVezMwUJKoGPgZMdULfYRmusnYvn5MfyaB1lUIERpkZ9Nv8zPOhPCCrTQdo00WJznSK1O");

class StripeApp extends Component {


  render() {

    if (!this.props.data.page) {
      return <p>...</p>;
    }

    const CARD_OPTIONS = {
      iconStyle: "solid",
      style: {
        base: {
          iconColor: "#ec7136",
          color: "#495057",
          fontWeight: 500,
          fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
          fontSize: "16px",
          fontSmoothing: "antialiased",
          ":-webkit-autofill": {
            color: "#ec7136"
          },
          "::placeholder": {
            color: "#ec7136"
          }
        },
        invalid: {
          iconColor: "red",
          color: "red"
        }
      }
    };

    const CardField = ({ onChange }) => (
      <div className="FormRow">
        <CardElement options={CARD_OPTIONS} onChange={onChange} />
      </div>
    );

    // const Field = ({
    //   label,
    //   id,
    //   type,
    //   placeholder,
    //   required,
    //   autoComplete,
    //   value,
    //   onChange
    // }) => (
    //   <div className="FormRow">
    //     <label htmlFor={id} className="FormRowLabel">
    //       {label}
    //     </label>
    //     <input
    //       className="FormRowInput"
    //       id={id}
    //       type={type}
    //       placeholder={placeholder}
    //       required={required}
    //       autoComplete={autoComplete}
    //       value={value}
    //       onChange={onChange}
    //     />
    //   </div>
    // );

    const SubmitButton = ({ processing, error, children, disabled }) => (
      <Button variant="primary"
        className={`SubmitButton ${error ? "SubmitButton--error" : ""}`}
        type="submit"
        disabled={processing || disabled}
      >
        {processing ? cookies.get("lang") === "LV" ?
          this.props.data.page.campaign.processingLv :
          this.props.data.page.campaign.processingEn
          : children}
      </Button>
    );

    const SubmitButtonSubscr = ({
      handleSubscribtion, processing,
      error,
      children,
      disabled
    }) => (
      <Button variant="primary"
        className={`SubmitButton ${error ? "SubmitButton--error" : ""}`}
        type="button"
        disabled={
          processing || disabled
        }
        onClick={
          (e) => {
            handleSubscribtion(e);
          }
        } target="_blank"
      >
        {processing ? cookies.get("lang") === "LV" ?
          this.props.data.page.campaign.processingLv :
          this.props.data.page.campaign.processingEn
          : children}
      </Button>
    );

    const ErrorMessage = ({ children }) => (
      <div className="ErrorMessage" role="alert">
        <svg width="16" height="16" viewBox="0 0 17 17">
          <path
            fill="#FFF"
            d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
          />
          <path
            fill="#6772e5"
            d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
          />
        </svg>
        {children}
      </div>
    );

    const ResetButton = ({ onClick }) => (
      <button type="button" className="ResetButton" onClick={onClick}>
        <svg width="32px" height="32px" viewBox="0 0 32 32">
          <path
            fill="#FFF"
            d="M15,7.05492878 C10.5000495,7.55237307 7,11.3674463 7,16 C7,20.9705627 11.0294373,25 16,25 C20.9705627,25 25,20.9705627 25,16 C25,15.3627484 24.4834055,14.8461538 23.8461538,14.8461538 C23.2089022,14.8461538 22.6923077,15.3627484 22.6923077,16 C22.6923077,19.6960595 19.6960595,22.6923077 16,22.6923077 C12.3039405,22.6923077 9.30769231,19.6960595 9.30769231,16 C9.30769231,12.3039405 12.3039405,9.30769231 16,9.30769231 L16,12.0841673 C16,12.1800431 16.0275652,12.2738974 16.0794108,12.354546 C16.2287368,12.5868311 16.5380938,12.6540826 16.7703788,12.5047565 L22.3457501,8.92058924 L22.3457501,8.92058924 C22.4060014,8.88185624 22.4572275,8.83063012 22.4959605,8.7703788 C22.6452866,8.53809377 22.5780351,8.22873685 22.3457501,8.07941076 L22.3457501,8.07941076 L16.7703788,4.49524351 C16.6897301,4.44339794 16.5958758,4.41583275 16.5,4.41583275 C16.2238576,4.41583275 16,4.63969037 16,4.91583275 L16,7 L15,7 L15,7.05492878 Z M16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 Z"
          />
        </svg>
      </button>
    );


    const CheckoutForm = () => {
      const stripe = useStripe();
      const elements = useElements();
      const [error, setError] = useState(null);
      const [errorSubscr, setErrorSubscr] = useState(null);
      const [cardComplete, setCardComplete] = useState(false);
      const [processing, setProcessing] = useState(false);
      const [processingSubscr, setProcessingSubscr] = useState(false);
      const [paymentMethod, setPaymentMethod] = useState(null);
      const [amount, setAmount] = useState({ number: "5", email: "" });
      // const [type, setType] = useState(false);
      const [billingDetails, setBillingDetails] = useState({
        email: "",
        name: ""
      });

      //const [checked, setChecked] = useState(false);
      const [radioValue, setRadioValue] = useState('price_1IkwOJBrw3XSlH4nKzT8TL8c');

      const radios = [{
        name: '9',
        value: 'price_1IkwOJBrw3XSlH4nKzT8TL8c'
      },
      {
        name: '25',
        value: 'price_1IkwOJBrw3XSlH4nS8mOdGz8'
      },
      {
        name: '50',
        value: 'price_1IkwOJBrw3XSlH4nhQh9YZRm'
      },
      ];






      const handleSubmit = async (event) => {
        event.preventDefault();

        //console.log(client_secret);
        //console.log(client_secret);
        if (!stripe || !elements) {
          // Stripe.js has not loaded yet. Make sure to disable
          // form submission until Stripe.js has loaded.
          return;
        }

        if (error) {
          elements.getElement("card").focus();
          return;
        }

        if (cardComplete) {
          setProcessing(true);
        }

        //console.log("signle");


        fetch("/wp-content/themes/kkc2020react/secret.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(amount)
        })
          .then(function (result) {
            //console.log(result);
            return result.json();
          })
          .then(function (data) {
            //const response = await fetch('/campaign');
            const client_secret = data;
            var card = elements.getElement(CardElement);
            //console.log(client_secret);
            payWithCard(stripe, card, client_secret.client_secret);
            return data;

          })
          .catch((error) => {
            console.error(error);
          });


        var payWithCard = function (stripe, card, client_secret) {
          stripe
            .confirmCardPayment(client_secret, {
              payment_method: {
                card: card,
                billing_details: billingDetails
              }
            })
            .then(function (result) {
              setProcessing(false);
              if (result.error) {
                // Show error to your customer
                setError(stripe.error);
              } else {
                // The payment succeeded!
                //console.log(result);
                setPaymentMethod(result.paymentIntent.payment_method);
              }
            });
        };

      };
      const handleSubscribtion = async (event) => {
        //console.log("event");
        event.preventDefault();

        //console.log(client_secret);
        if (!stripe || !elements) {
          //console.log("asdad");
          // Stripe.js has not loaded yet. Make sure to disable
          // form submission until Stripe.js has loaded.
          return;
        }

        if (error) {
          //console.log("error");
          elements.getElement("card").focus();
          return;
        }

        if (cardComplete) {
          setProcessing(true);
        }

        var handleFetchResult = function (result) {
          if (!result.ok) {
            return result.json().then(function (json) {
              if (json.error && json.error.message) {
                throw new Error(result.url + ' ' + result.status + ' ' + json.error.message);
              }
            }).catch(function (err) {
              showErrorMessage(err);
              throw err;
            });
          }
          return result.json();
        };

        //console.log("sunscrshn");
        fetch("https://checkout.kanepes.lv/setup")
          .then(handleFetchResult)
          .then(function (json) {
            // var publishableKey = json.publishableKey;
            //var basicPriceId = amount.number;
            //var basicPriceId = "price_1Ik4neBrw3XSlH4nhsfwDaTl";
            var basicPriceId = radioValue;
            //console.log(basicPriceId);

            createCheckoutSession(basicPriceId).then(async function (data) {
              const stripe = await stripePromise;
              // Call Stripe.js method to redirect to the new Checkout page
              stripe
                .redirectToCheckout({
                  sessionId: data.sessionId,
                  //customerEmail: billingDetails.email
                })
                .then(handleResult);
            });

          });

        var createCheckoutSession = function (priceId) {
          return fetch("https://checkout.kanepes.lv/create-checkout-session", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              priceId: priceId
            })
          }).then(handleFetchResult);
        };

        // Handle any errors returned from Checkout
        var handleResult = function (result) {
          if (result.error) {
            showErrorMessage(result.error.message);
          }
        };

        var showErrorMessage = function (message) {
          var errorEl = document.getElementById("error-message")
          errorEl.textContent = message;
          errorEl.style.display = "block";
        };



      };


      const reset = () => {
        setError(null);
        setErrorSubscr(null);
        setProcessing(false);
        setProcessingSubscr(false);
        setPaymentMethod(null);
        //setType(null);
        setAmount({ number: "" });
        setBillingDetails({
          email: "",
          name: ""
        });
      };

      return paymentMethod ? (
        <div className="Result">
          <div className="ResultTitle" role="alert">
            {cookies.get("lang") === "LV" ?
              this.props.data.page.campaign.successTitleLv : this.props.data.page.campaign.successTitleEn
            }
          </div>
          <div className="ResultMessage">
            {cookies.get("lang") === "LV" ?
              this.props.data.page.campaign.successDescriptionLv
              : this.props.data.page.campaign.successDescriptionEn
            }
          </div>
          <ResetButton onClick={reset} />
        </div>
      ) : (
        <Form className="Form"
          onSubmit={
            handleSubmit.bind(this)
          } >

          <h2>{cookies.get("lang") === "LV" ?
            this.props.data.page.campaign.bankCardTitleLv :
            this.props.data.page.campaign.bankCardTitleEn
          }</h2>
          <Form.Group className="FormGroup">
            <Form.Control
              id="name"
              type="text"
              placeholder={cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.nameLv :
                this.props.data.page.campaign.nameEn
              }
              required
              autoComplete="name"
              value={billingDetails.name}
              onChange={(e) => {
                setBillingDetails({ ...billingDetails, name: e.target.value });
              }}
            ></Form.Control >
          </Form.Group >
          <Form.Group className="FormGroup" >
            <Form.Control
              id="email"
              type="email"
              placeholder={cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.emailLv :
                this.props.data.page.campaign.emailEn
              }
              required
              autoComplete="email"
              value={billingDetails.email}
              onChange={(e) => {
                setBillingDetails({ ...billingDetails, email: e.target.value });
                setAmount({ ...amount, email: e.target.value });
              }}
            ></Form.Control>
          </Form.Group>
          <Form.Group as={Row} className="FormGroup" >
            <Form.Label column sm="4" >
              {cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.amountTextLv :
                this.props.data.page.campaign.amountTextEn
              }
            </Form.Label>
            <Col sm="8">
              <Form.Control
                id="number"
                type="number"
                name="quantity"
                min="5"
                required
                value={amount.number}
                onChange={(e) => {
                  setAmount({ ...amount, number: e.target.value });
                }}
              ></Form.Control></Col>
          </Form.Group>
          <Form.Group className="FormGroup">
            <CardField
              onChange={(e) => {
                setError(e.error);
                setCardComplete(e.complete);
              }}
            />
          </Form.Group>
          {error && <ErrorMessage>{error.message}</ErrorMessage>}
          <SubmitButton processing={processing} error={error} disabled={!stripe}>
            {cookies.get("lang") === "LV" ?
              this.props.data.page.campaign.payLv :
              this.props.data.page.campaign.payEn
            }
          </SubmitButton>
          <hr className="campaignHr" />
          <h2>{cookies.get("lang") === "LV" ?
            this.props.data.page.campaign.subscriptionTitleLv :
            this.props.data.page.campaign.subscriptionTitleEn
          }</h2>
          <ButtonGroup toggle className="justify-content-center" >
            {radios.map((radio, idx) => (
              <ToggleButton
                key={idx}
                className="priceButton"
                type="radio"
                variant="primary"
                name="radio"
                value={radio.value}
                checked={radioValue === radio.value}
                onChange={(e) => setRadioValue(e.currentTarget.value)}
              >
                {radio.name} € / {cookies.get("lang") === "LV" ?
                  this.props.data.page.campaign.perMonthLv :
                  this.props.data.page.campaign.perMonthEn
                }
              </ToggleButton>
            ))}
          </ButtonGroup>
          <SubmitButtonSubscr handleSubscribtion={
            handleSubscribtion.bind(this)
          }
            processing={
              processingSubscr
            }
            error={
              errorSubscr
            }
            disabled={
              !stripe
            } >
            {cookies.get("lang") === "LV" ?
              this.props.data.page.campaign.payLv :
              this.props.data.page.campaign.payEn
            }
          </SubmitButtonSubscr>
        </Form>
      );
    };

    const ELEMENTS_OPTIONS = {
      fonts: [
        {
          cssSrc: "https://fonts.googleapis.com/css?family=Roboto"
        }
      ]
    };




    // const balance = StripeBalanceOutput();

    // console.log(balance);















    // Make sure to call `loadStripe` outside of a component’s render to avoid
    // recreating the `Stripe` object on every render.

    //console.log(this);

    //var myCurrentDate = new Date();
    // var date = myCurrentDate.getDate() + '.' + (myCurrentDate.getMonth() + 1) + '.' + myCurrentDate.getFullYear() + '.';
    // console.log(date)
    var template_email = '';

    cookies.get("lang") === "LV" ?
      template_email = 'template_by2facg' : template_email = 'template_kk9z6yq';
    const RoomDonationForm = () => {
      console.log(template_email);

      const [formsuccess, setFormSuccess] = useState(false);
      //const [startDate, setStartDate] = useState(new Date());
      function sendEmail(e) {
        e.preventDefault();



        emailjs.sendForm('service_os0asya', template_email, e.target, 'user_uCC4mhrAzWyJ42Uvlreqo')
          .then((result) => {
            setFormSuccess(true);
            console.log(result.text);
          }, (error) => {
            setFormSuccess(false);
            console.log(error.text);
          });
      }

      const reset = () => {
        setFormSuccess(false);
      };

      return formsuccess ? (
        <div className="Result">
          <div className="ResultTitle" role="alert">
            {cookies.get("lang") === "LV" ?
              this.props.data.page.campaign.successTitleLv : this.props.data.page.campaign.successTitleEn
            }
          </div>
          <div className="ResultMessage">
            {cookies.get("lang") === "LV" ?
              this.props.data.page.campaign.telpaSuccessLv
              : this.props.data.page.campaign.telpaSuccessEn
            }
          </div>
          <ResetButton onClick={reset} />
        </div>
      ) : (
        <Form className="Form contact-form" onSubmit={sendEmail}>
          <hr className="campaignHr" />
          <h2>{cookies.get("lang") === "LV" ?
            this.props.data.page.campaign.telpaTitleLv :
            this.props.data.page.campaign.telpaTitleEn
          }
          </h2>
          <Row>
            <Col>
              {cookies.get("lang") === "LV" ?
                <p dangerouslySetInnerHTML={{ __html: this.props.data.page.campaign.telpaDescriptionLv }} /> :
                <p dangerouslySetInnerHTML={{ __html: this.props.data.page.campaign.telpaDescriptionEn }} />
              }
            </Col>
          </Row>
          <Form.Group className="FormGroup" >
            <Form.Control type="hidden"
              name="contact_number">
            </Form.Control>
          </Form.Group>
          <Form.Group className="FormGroup" >
            <Form.Control type="text"
              name="user_name"
              required
              placeholder={cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.nosaukumsvardsUzvardsLv :
                this.props.data.page.campaign.nosaukumsvardsUzvardsEn
              }>
            </Form.Control>
            {/* <Form.Control type="hidden"
              name="user_date" value={{date}}
              >
            </Form.Control> */}
          </Form.Group>
          <Form.Group className="FormGroup" >
            <Form.Control type="text" name="user_regnumber" required
              placeholder={cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.regnrPersonasKodsLv :
                this.props.data.page.campaign.regnrPersonasKodsEn
              }>
            </Form.Control>
          </Form.Group>
          <Form.Group className="FormGroup" >
            <Form.Control type="text" name="user_address" required
              placeholder={cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.adreseLv :
                this.props.data.page.campaign.adreseEn
              }>
            </Form.Control>
          </Form.Group>
          <Form.Group className="FormGroup" >
            <Form.Control type="text" name="user_account" required
              placeholder={cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.bankasKontsLv :
                this.props.data.page.campaign.bankasKontsEn
              }>
            </Form.Control>
          </Form.Group>
          <Form.Group className="FormGroup" >
            <Form.Control type="text" name="user_bank" required
              placeholder={cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.bankaLv :
                this.props.data.page.campaign.bankaEn
              }>
            </Form.Control>
          </Form.Group>
          <Form.Group className="FormGroup" >
            <Form.Control type="email"
              name="user_email" required
              placeholder={cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.telpaEpastsLv :
                this.props.data.page.campaign.telpaEpastsEn
              }>
            </Form.Control>
          </Form.Group>
          <Form.Group className="FormGroup" >
            <Form.Control type="text" name="user_phone" required
              placeholder={cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.telpaTalrunisLv :
                this.props.data.page.campaign.telpaTalrunisEn
              }>
            </Form.Control>
          </Form.Group>
          {/* <Form.Group className="FormGroup" >
            <DatePicker selected={startDate} onChange={date => setStartDate(date)} />
          </Form.Group> */}
          <Form.Group className="FormGroup" >
            <Form.Control as="textarea" rows={3} name="message" placeholder={cookies.get("lang") === "LV" ?
              this.props.data.page.campaign.telpaKomentariLv :
              this.props.data.page.campaign.telpaKomentariEn
            } />
          </Form.Group>

          <SubmitButton >
            {cookies.get("lang") === "LV" ?
              this.props.data.page.campaign.telpaSubmitLv :
              this.props.data.page.campaign.telpaSubmitEn
            }
          </SubmitButton>

        </Form>



      );
    }


    const ProgressDonations = () => {
      const [balance, setBalance] = useState();

      useEffect(() => {
        let isCancelled = false;
        const runAsync = async () => {
          try {
            if (!isCancelled) {
             // let response = await fetch('/wp-content/themes/kkc2020react/balance.php');
             // let responseJson = await response.json();
              //console.log(responseJson.balance_available);
              setBalance(parseInt(this.props.data.page.campaign.currentAmountEur));
              //setBalance(parseInt(this.props.data.page.campaign.currentAmountEur) + parseInt(responseJson.balance_available));
            }
          } catch (e) {
            if (!isCancelled) {
              console.error(e);
            }
          }
        };

        runAsync();

        return () => {
          isCancelled = true;
        };
      }, []);

      return (
        <div>

          <h1>{cookies.get("lang") === "LV" ?
            this.props.data.page.campaign.currentlyDonatedLv :
            this.props.data.page.campaign.currentlyDonatedEn
          } {balance + '.00 EUR'} {cookies.get("lang") === "LV" ?
            this.props.data.page.campaign.ofLv :
            this.props.data.page.campaign.ofEn
            } {this.props.data.page.campaign.targetAmountEur + '.00 EUR'}</h1>

          <ProgressBar variant="warning"
            now={
              (balance * 100) / this.props.data.page.campaign.targetAmountEur
            }
          />
        </div>
      );
    }


    //console.log(balance);

    // useEffect(() => {
    //   let isCancelled = false;
    //   try {
    //     let response = await fetch('/wp-content/themes/kkc2020react/balance.php');
    //     let responseJson = await response.json();
    //     //console.log(responseJson);
    //     setBalance(responseJson);
    //   } catch (error) {
    //     console.error(error);
    //   }
    //   // fetch('/wp-content/themes/kkc2020react/balance.php')
    //   //   .then(data => {
    //   //     return data.json();
    //   //   })
    //   //   .then(data => {
    //   //         console.log(data);
    //   //     setBalance(data);
    //   //   })
    //   //   .catch(error => {
    //   //     console.error(error);
    //   //   });
    // }, []);








    return (
      <>
      <div id="klara" data-headertitle="Klāra" className="AppWrapper container">
        <div id="error-message" className="error-message"></div>

        <Container fluid>
          <Row className="justify-content-center mt-5 mb-5" >
            <Col md="12" className="text-center" >
              <h1>{cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.titleLv :
                this.props.data.page.campaign.titleEn
              }</h1>

            </Col>
          </Row>

          <Row className="justify-content-center" >
            <Col md="12" className="text-center" >
              <div className='player-wrapper'>
                <ReactPlayer playing muted controls
                  className="campaignVideo"
                  url={cookies.get("lang") === "LV" ?
                    this.props.data.page.campaign.videoUrlLv :
                    this.props.data.page.campaign.videoUrlEn
                  }
                />
              </div>

            </Col>
          </Row>
          <Row className="justify-content-center mt-5 mb-5" >
            <Col md="8" className="text-center">
              {cookies.get("lang") === "LV" ?
                <p dangerouslySetInnerHTML={{ __html: this.props.data.page.campaign.descriptionLv }} /> :
                <p dangerouslySetInnerHTML={{ __html: this.props.data.page.campaign.descriptionEn }} />
              }
            </Col>
          </Row>
          <Row className="justify-content-center" >
            <Col md="10" className="text-center">

              <div className="single-share-btns">
                <span>
                  {cookies.get("lang") === "LV" &&
                    this.props.data.themeGeneralSettings.optionsPage
                      .singlePostShareButtonsText}
                  {cookies.get("lang") === "EN" &&
                    this.props.data.themeGeneralSettings.optionsPage
                      .singlePostShareButtonsTextEn}
                </span>
                <ShareButtons />
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center mt-5 mb-5" >
            <Col md="10" className="text-center">
              <ProgressDonations />

            </Col>
          </Row>
          <Row className="justify-content-center" >
            <Col md="6" >
              <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
                <CheckoutForm />
              </Elements>
            </Col>
          </Row>
          <Row className="justify-content-center" >
            <Col md="6" className="bankCol">

              <hr className="campaignHr" />
              <h2>{cookies.get("lang") === "LV" ?
                this.props.data.page.campaign.bankStatementTitleLv :
                this.props.data.page.campaign.bankStatementTitleEn
              }</h2>
              {cookies.get("lang") === "LV" ?
                <p dangerouslySetInnerHTML={{ __html: this.props.data.page.campaign.bankLv }} /> :
                <p dangerouslySetInnerHTML={{ __html: this.props.data.page.campaign.bankEn }} />
              }

              <RoomDonationForm />
              <hr className="campaignHr" />
              <Button className="SubmitButton"
                href={
                  this.props.data.page.campaign.buttonUrl
                }
                target="_blank" >
                {cookies.get("lang") === "LV" ?
                  this.props.data.page.campaign.buttonTextLv :
                  this.props.data.page.campaign.buttonTextEn
                }</Button>
            </Col>
          </Row>
        </Container>
      </div>
      <FooterPage />
      </>
    );

  }
};

const campaignQuery = gql`
query campaignQuery {
  page(id: "cG9zdDoxMDAw=") {
    campaign {
      currentAmountEur
      targetAmountEur
      descriptionEn
      descriptionLv
      nameEn
      nameLv
      payEn
      payLv
      successDescriptionEn
      successDescriptionLv
      successTitleEn
      successTitleLv
      titleEn
      titleLv
      videoUrlLv
      videoUrlEn
      processingEn
      processingLv
      emailEn
      emailLv
      cardNumberEn
      cardNumberLv
      amountTextEn
      amountTextLv
      bankEn
      bankLv
      buttonTextEn
      buttonTextLv
      buttonUrl
      bankCardTitleEn
      bankCardTitleLv
      bankStatementTitleEn
      bankStatementTitleLv
      currentlyDonatedEn
      currentlyDonatedLv
      fieldGroupName
      manageBillingEn
      manageBillingLv
      ofEn
      ofLv
      perMonthEn
      perMonthLv
      subscriptionTitleEn
      subscriptionTitleLv
      adreseEn
      adreseLv
      bankaEn
      bankaLv
      bankasKontsEn
      bankasKontsLv
      nosaukumsvardsUzvardsEn
      nosaukumsvardsUzvardsLv
      regnrPersonasKodsEn
      regnrPersonasKodsLv
      telpaDescriptionEn
      telpaTitleLv
      telpaTitleEn
      telpaTalrunisLv
      telpaTalrunisEn
      telpaSuccessLv
      telpaSuccessEn
      telpaSubmitLv
      telpaSubmitEn
      telpaEpastsLv
      telpaEpastsEn
      telpaDescriptionLv
      telpaKomentariLv
      telpaKomentariEn
    }
  }
  themeGeneralSettings {
    optionsPage {
      singlePostShareButtonsText
      singlePostShareButtonsTextEn
    }
  }
}




`;

export default graphql(campaignQuery)(StripeApp)
